import { MyHTTPConnection } from '../global/MyHTTPConnection.js';
import { Publication } from '../models/PublicationModel.js';

export class PublicationService {
  static async getPublications() {
    const response = await fetch(MyHTTPConnection.HTTP_URL + 'publication/');
    const data = await response.json();
    return data.map(publication => new Publication(publication));
  }
}